import { FC, useMemo } from 'react';
import { Flex, FlexProps, Text } from '@eqi-investimentos/react';
import { useTheme } from '@chakra-ui/react';
import { getChartInstitutionColor } from '@/modules/Wallet/ui/MyWalletSummary/InstitutionsWalletChart/options';
import { getColorChartAssetByToken } from '@/utils/chart';
import { formatToPercentage } from '@/utils/format';
export const AllocationCell: FC<AllocationCellProps> = ({
  rowIndex,
  value,
  colors,
  isDesktop = false,
  ...props
}) => {
  const {
    isDarkMode
  } = useTheme();
  const colorByToken = useMemo(() => getColorChartAssetByToken(rowIndex, isDarkMode), [rowIndex, isDarkMode]);
  return <Flex alignItems="center" gap={isDesktop ? 5 : 2.5} {...props} data-sentry-element="Flex" data-sentry-component="AllocationCell" data-sentry-source-file="index.tsx">
      <Flex w={isDesktop ? '0.9375rem' : 2.5} h={isDesktop ? '0.9375rem' : 2.5} bgColor={colors ? getChartInstitutionColor(rowIndex, colors) : colorByToken} borderRadius="sm" data-sentry-element="Flex" data-sentry-source-file="index.tsx" />
      <Text as="span" fontSize={isDesktop ? 'sm' : 'xs'} fontWeight="bold" lineHeight="1.125rem" minW="1.875rem" color="content.primary" data-sentry-element="Text" data-sentry-source-file="index.tsx">
        {formatToPercentage(value)}
      </Text>
    </Flex>;
};
type AllocationCellProps = Omit<FlexProps, 'children'> & {
  rowIndex: number;
  value: number;
  colors?: string[];
  isDesktop?: boolean;
};